module.exports = __webpack_public_path__ + "img/filter-page.7f1265a6.jpg";